import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { FaTiktok, FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import tesbihLogo from '../../assets/logo22.png';
import { collection, onSnapshot, query } from 'firebase/firestore'; 
import { db } from '../firebase/firebase-config';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  // 1. Kategorileri Çeken Effect
  useEffect(() => {
    const q = query(collection(db, "categories"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const catData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCategories(catData);
    }, (error) => {
      console.error("Kategoriler çekilirken hata:", error);
    });

    return () => unsubscribe();
  }, []);

  // 2. SCROLL KİLİTLEME MANTIĞI (Yeni eklenen kısım)
  useEffect(() => {
    if (isOpen) {
      // Menü açıldığında body scroll'u kapat
      document.body.style.overflow = 'hidden';
    } else {
      // Menü kapandığında body scroll'u aç
      document.body.style.overflow = 'unset';
    }

    // Component kapandığında scroll'un kilitli kalmaması için temizlik
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleMobileClick = (path) => {
    setIsOpen(false);
    setIsCategoryOpen(false);
    navigate(path);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={() => setIsOpen(false)}>
          <img src={tesbihLogo} alt="Tesbihçimen Logo" />
        </Link>

        <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        <div className={`nav-content ${isOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li><Link to="/" onClick={() => setIsOpen(false)}>Anasayfa</Link></li>
            
            <li className={`dropdown ${isCategoryOpen ? 'open' : ''}`}>
              <div 
                className="dropdown-trigger" 
                onClick={(e) => {
                  if(window.innerWidth <= 992) {
                    setIsCategoryOpen(!isCategoryOpen);
                  }
                }}
              >
                Kategoriler <FaChevronDown className={`arrow ${isCategoryOpen ? 'rotate' : ''}`} />
              </div>
              
              <ul className="dropdown-menu">
                {/* MOBİL İÇİN TÜM KATEGORİLER LİNKİ */}
                <li className="mobile-only-link">
                  <Link to="/kategoriler" onClick={() => handleMobileClick('/kategoriler')}>
                    TÜM KATEGORİLERİ GÖR
                  </Link>
                </li>

                {categories.length > 0 ? (
                  categories.map((cat) => (
                    <li key={cat.id}>
                      <Link 
                        to={`/kategori/${cat.slug}`} 
                        onClick={() => handleMobileClick(`/kategori/${cat.slug}`)}
                      >
                        {cat.title}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li><span className="loading-text">Yükleniyor...</span></li>
                )}
              </ul>
            </li>
            
            <li><Link to="/urunler" onClick={() => setIsOpen(false)}>Ürünler</Link></li>
          </ul>

          <div className="nav-right">
            <div className="social-icons">
              <a href="https://www.tiktok.com/@tesbihcimen.collection" target="_blank" rel="noreferrer"><FaTiktok /></a>
            </div>
            <button className="contact-btn" onClick={() => handleMobileClick('/iletisim')}>İletişime Geç</button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;